import { useState } from 'react'
import { SwiperSlide } from 'swiper/react'
import { A11y, Navigation, Pagination } from 'swiper/modules'
import { TonalitaDetailObject } from '@gql/graphql'
import { useTrans } from '@hooks/index'
import { CarouselCard } from '@components/molecules'
import { GenericSection, GenericSlider, TonalitaSectionGalleryModal } from '@components/organisms'
import styles from './TonalitaSection.module.sass'

interface Props {
  tonalita: TonalitaDetailObject
  className?: string
}

const TonalitaSection = (props: Props) => {
  const { tonalita = undefined, className = '' } = props

  const t = useTrans()
  const [modalIndex, setModalIndex] = useState<number>(null)

  return tonalita?.tonalitaCollezione?.gallery?.length ? (
    <>
      <GenericSection
        item={{
          name: t('Galleria'),
        }}
        className={`${styles.root} ${className}`}
      >
        <GenericSlider
          id={`tonalita_${tonalita.tonalitaCollezione.id}`}
          notch
          navigationPos="pagination"
          conf={{
            slidesPerView: 1,
            spaceBetween: 10,
            modules: [A11y, Navigation, Pagination],
            navigation: true,
            pagination: { clickable: true },
            breakpoints: {
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            },
          }}
        >
          {tonalita.tonalitaCollezione.gallery.map((i, index) => (
            <SwiperSlide key={index}>
              <CarouselCard
                item={{
                  pk: i.id,
                  image: i.url,
                  // imageAlt: TODO - manca il campo - regola?
                }}
                onClick={() => setModalIndex(index)}
              />
            </SwiperSlide>
          ))}
        </GenericSlider>
      </GenericSection>
      <TonalitaSectionGalleryModal
        id={`tonalitasectiongallerymodal`}
        open={modalIndex !== null}
        initialSlide={modalIndex}
        onClose={() => setModalIndex(null)}
        tonalita={tonalita}
      />
    </>
  ) : (
    <></>
  )
}

export default TonalitaSection
